import clsx from "clsx";
import { LabelHeaderCell } from "../HeaderCell/LabelHeaderCell";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { LabelItem } from "../../LabelItem";
import { ACCOUNT_LIST } from "@/features/Labeling/labeling.constants";

export const AccountLabelColDef = {
    headerName: "Account Label",
    colId: "label",
    pinned: "left" as const,
    width: 300,
    suppressSizeToFit: true,
    suppressHeaderMenuButton: true,
    sortable: false,
    headerComponentParams: {
        innerHeaderComponent: LabelHeaderCell,
    },
    valueGetter: (params) => {
        return params.data.account?.label || params.data.rowHeader;
    },
};

export const AccountLabelCellRenderer = ({
    label,
    showReadableLabel,
    isDisabled,
    isTentative,
}: {
    showReadableLabel: boolean;
    isDisabled: boolean;
    isTentative: boolean;
    label?: AccountLabel | null;
}) => {
    if (!label)
        return (
            <div
                className={clsx(
                    "size-full",
                    isDisabled ? "cursor-default" : "cursor-pointer",
                )}
            />
        );

    return (
        <div
            className={clsx(
                "flex  size-full items-center justify-between",
                !isDisabled && !isTentative ? "opacity-100" : "opacity-50",
                isDisabled ? "cursor-default" : "cursor-pointer",
            )}
        >
            <LabelItem
                className="w-full"
                label={ACCOUNT_LIST[label]}
                prettify={showReadableLabel}
                dot
            />
        </div>
    );
};
